import { render } from "./MainForm.vue?vue&type=template&id=23b04b9c&scoped=true"
import script from "./MainForm.vue?vue&type=script&lang=js"
export * from "./MainForm.vue?vue&type=script&lang=js"

import "./MainForm.vue?vue&type=style&index=0&id=23b04b9c&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b04b9c"]])

export default __exports__